import { REDUX_ACTIONS, GAME_ID, LEVEL_COUNT } from '../../data/constants';

const initState = {
  isOnboarded: false,
  highestLevelEarned: 0,
};

const screenReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
      };

    case REDUX_ACTIONS.ROUND_END: {
      const { levelIndex, isSuccess, isEarlyExit } = payload;
      if (isSuccess && !isEarlyExit) {
        const highestLevelEarned = Math.min(levelIndex + 1, LEVEL_COUNT - 1);
        return {
          ...state,
          highestLevelEarned,
        };
      }
      return {
        ...state,
        highestLevelEarned: levelIndex,
      };
    }

    default:
      return state;
  }
};

export default screenReducer;
